// extracted by mini-css-extract-plugin
module.exports = {"slider-input-container":"inpus_slider_slider-input-container__2wRt4","slider-input":"inpus_slider_slider-input__gznf3"};